<template>
  <main class="terms">
    <p>{{ msg }}</p>
  </main>
</template>

<script>
  export default {
    name: 'terms',
    data () {
      return {
        msg: 'Terms'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/pages/Terms.vue